import {
    Component, Input, Output, EventEmitter,
    AfterViewInit, OnDestroy,
    OnChanges, SimpleChanges, SimpleChange,
    ElementRef
} from '@angular/core';

@Component({
    selector: 'al-progressbar',
    template: `
        <div [ngClass]="{'ui-steps ui-widget ui-helper-clearfix':true,'ui-steps-readonly':readonly}" [ngStyle]="style" [class]="styleClass">
            <!-- START : Progressbar steps -->
			<p *ngIf="model.length > 0" class="al-hidden-gt720"><strong> {{ model[activeIndex].labelSmall }} {{ofText}} {{ model.length }}: {{ model[activeIndex].label}}</strong></p>
            <ul>
                <li *ngFor="let item of model; let i = index" class="ui-steps-item" #menuitem
                    [ngClass]="{'ui-state-highlight':(i === activeIndex),'ui-state-default':(i !== activeIndex),
                        'ui-state-disabled':item.disabled||(i !== activeIndex && readonly)}">
                    <a *ngIf="!item.routerLink" [href]="item.url||'#'" class="ui-menuitem-link" (click)="itemClick($event, item, i)" [attr.target]="item.target" [attr.id]="item.id">
                        <span class="ui-steps-number">{{i + 1}}</span>
                        <span class="ui-steps-title">{{item.label}}</span>
                    </a>
                    <a *ngIf="item.routerLink" [routerLink]="item.routerLink" [queryParams]="item.queryParams" [routerLinkActive]="'ui-state-active'" [routerLinkActiveOptions]="item.routerLinkActiveOptions||{exact:false}" class="ui-menuitem-link" (click)="itemClick($event, item, i)" [attr.target]="item.target" [attr.id]="item.id">
                        <span class="ui-steps-number">{{i + 1}}</span>
                        <span class="ui-steps-title">{{item.label}}</span>
                    </a>
                </li>
            </ul>
            <!-- END : Progressbar steps -->

            <!-- START : Progressbar content -->
            <ng-content></ng-content>
            <!-- END : Progressbar content -->
        </div>
    `
})
export class AlProgressBarComponent implements AfterViewInit, OnDestroy, OnChanges {

    @Input() activeIndex = 0;

    @Input() model = [];

    @Input() readonly: boolean = true;

    @Input() style: any;

    @Input() styleClass: string;

    @Input() ofText: string = 'of';

    @Output() activeIndexChange: EventEmitter<any> = new EventEmitter();

    constructor(private _el: ElementRef) { }

    itemClick(event: Event, item, i: number) {
        if (this.readonly || item.disabled) {
            event.preventDefault();
            return;
        }

        this.activeIndexChange.emit(i);

        // If index of clicked step ( item ) is less then activeIndex then go to Previous step
        if (i < this.activeIndex) {
            this.goToPreviousStep(i);
        }

        // If index of clicked step ( item ) is greater then activeIndex then go to Next step
        if (i > this.activeIndex) {
            if (this.activeIndex < this.model.length) {
                this.goToNextStep(i);
            }
        }

        if (!item.url) {
            event.preventDefault();
        }

        if (item.command) {
            item.command({
                originalEvent: event,
                item: item,
                index: i
            });
        }
    }

    /**
     * Go to next step and mark previous step as completed
     *
     * @method goToNextStep
     * @param activeIndex value of active step
     *
     */
    public goToNextStep(activeIndex) {
        let steps = this._el.nativeElement.querySelectorAll('.ui-steps-item');

        if (steps) {
            for (let i = activeIndex - 1; i >= 0; i--) {
                // Mark all previous item ( steps ) completed from current step
                steps[i].classList.remove('ui-state-default');
                steps[i].classList.remove('ui-state-disabled');
                steps[i].classList.add('ui-state-completed');

                // if activeIndex value is equal to total item length - 1,
                // it means if it is last item and user clicks on next button then mark it as completed
                if ((i + 1) === this.model.length - 1) {
                    steps[i + 1].classList.remove('ui-state-highlight');
                    steps[i + 1].classList.remove('ui-state-disabled');
                    steps[i + 1].classList.add('ui-state-completed');
                }
            }
        }
    }

    /**
     * Go to previous step and mark next step as inactive
     *
     * @method goToPreviousStep
     * @param activeIndex value of active step
     *
     */
    public goToPreviousStep(activeIndex) {
        let steps = this._el.nativeElement.querySelectorAll('.ui-steps-item');

        if (steps) {
            // First remove all hightlight and completed classes from all the steps
            [].forEach.call(steps, (step, index) => {
                step.classList.remove('ui-state-highlight');
                step.classList.remove('ui-state-completed');
                step.classList.add('ui-state-default', 'ui-state-disabled');
            });

            for (let i = 0; i < activeIndex; i++) {
                steps[i].classList.remove('ui-state-default');
                steps[i].classList.remove('ui-state-disabled');
                steps[i].classList.add('ui-state-completed');
            }
        }
    }

    /**
     * Detect changes of "activeIndex" input value (in Parent compoent)
     *
     * @method ngOnChanges
     * @param changes object which contains current and previous value of activeIndex
     *
     */
    ngOnChanges(changes: SimpleChanges) {
        const activeIndex: SimpleChange = changes.activeIndex;
        this.activeIndex = activeIndex.currentValue;

        if (activeIndex.currentValue < activeIndex.previousValue) {
            this.goToPreviousStep(this.activeIndex);
        }

        if (activeIndex.currentValue > activeIndex.previousValue) {
            if (this.activeIndex < this.model.length) {
                this.goToNextStep(this.activeIndex);
            }
        }
    }

    setCompletedIndexes() {
        let steps = this._el.nativeElement.querySelectorAll('.ui-steps-item');
        for (let i = 0; i < this.activeIndex; i++) {
            steps[i].classList.add('ui-state-completed');
        }
    }

    ngAfterViewInit() {
        this.setCompletedIndexes();
    }

    ngOnDestroy() {

    }

}
